import { parseISO, isValid, isBefore } from 'date-fns';
import { INPUT_TYPES } from '../constants';

import validPhoneNumber from './validPhoneNumber';

const telephoneRegex = /^$|^[^a-zA-Z]+$/;
const dateRegex = /^20[1-9]\d-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/;
const Time24Regex = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateEmail(value) {
	if (!emailRegex.test(value)) {
		return 'Please enter a valid email';
	}

	return false;
}

function validatePhone(value) {
	if (!telephoneRegex.test(value) || !validPhoneNumber(value)) {
		return 'Please enter a valid phone number';
	}

	return false;
}

function validateTime(value) {
	if (!Time24Regex.test(value)) {
		return 'Please enter a valid time';
	}

	return false;
}

function validateDate(value, min) {
	if (!dateRegex.test(value)) {
		return 'Please enter a valid date';
	}

	const date = parseISO(value);

	if (!isValid(date)) {
		return 'Please enter a valid date';
	}

	if (min && isBefore(date, parseISO(min))) {
		return 'Please enter a future date';
	}

	return false;
}

export default function validateInputType({ inputType, value, min }) {
	if (value && inputType === INPUT_TYPES.PHONE) {
		return validatePhone(value);
	}

	// Dev note: Add inputType validations here, when required
	// if (inputType === INPUT_TYPES.NUMBER) {}

	if (value && inputType === INPUT_TYPES.DATE) {
		return validateDate(value, min);
	}

	if (value && inputType === INPUT_TYPES.TIME) {
		return validateTime(value);
	}

	if (value && inputType === INPUT_TYPES.EMAIL) {
		return validateEmail(value);
	}
	return false;
}
